export class MotivationPrinciple {

    name:string;
    y:string;
    description:string;

    constructor() {
        this.name = "";
        this.y = "";
        this.description = "";
    }

}